// extracted by mini-css-extract-plugin
export default {"section":"style_section__zu92Y","sectionContent":"style_sectionContent__-GwXn"};